// Copyright (c) Bentley Systems
import { ReactComponent as LinkageAttribute } from "./linkageAttribute.svg";
import { ReactComponent as BecsLogo } from "./BECS_Product_Logo.svg";
import { ReactComponent as BecsIcon } from "./BECS_Product_Icon.svg";
import LogAnim from "./LogAnim";
import { ReactComponent as Log } from "./Log.svg";
import AdministrationAnim from "./AdministrationAnim";
import ArchitectsManagementAnim from "./ArchitectsManagementAnim"; 
import { ReactComponent as ArchitectsManagement } from "./ArchitectsManagement.svg";
import SubscribedProjectsAnim from "./SubscribedProjectsAnim";
import ListAnim from "./ListAnim";
import ScriptRunAnim from "./ScriptRunAnim";
import DetailsAnim from "./DetailsAnim";
import { ReactComponent as Administration } from "./Administration.svg";
import { ReactComponent as IModelValueList } from "./iModelValueList.svg";
import { ReactComponent as ARExperience } from "./ARExperience.svg";
import { ReactComponent as Attributes } from "./Attributes.svg";
import { ReactComponent as ColorSettings } from "./ColorSettings.svg";
import { ReactComponent as ColourSettings } from "./ColourSettings.svg";
import { ReactComponent as DawWebScreen } from "./DawWebScreen.svg";
import { ReactComponent as Mapping } from "./Mapping.svg";
import { ReactComponent as StatusSuccessColor } from "./StatusSuccessColor.svg";
import { ReactComponent as StatusSuccessColorMuted } from "./StatusSuccessColorMuted.svg";
import { ReactComponent as PasswordManagement } from "./PasswordManagement.svg";
import { ReactComponent as TabListing } from "./TabListing.svg";
import { ReactComponent as Projects } from "./Projects.svg";
import { ReactComponent as SubscribedProjects } from "./SubscribedProjects.svg";
import { ReactComponent as Organizations } from "./Organizations.svg";
import { ReactComponent as SubscribedOrganizations } from "./SubscribedOrganizations.svg";
import { ReactComponent as ApiTesting } from "./ApiTesting.svg";
import { ReactComponent as OnPremRouting } from "./OnPremRouting.svg";
import { ReactComponent as Interoperability } from "./LogicGate.svg";
import { ReactComponent as IndustryList } from "./IndustryList.svg";
import { ReactComponent as MonitorList } from "./MonitorList.svg";
import { ReactComponent as ConfirmScript } from "./ConfirmScript.svg";
import { ReactComponent as Attachment } from "./Attachment.svg";
import { ReactComponent as ExecutionTypeList } from "./ExecutionTypeList.svg";
import { ReactComponent as LifeCycleList } from "./LifeCycleList.svg";
import { ReactComponent as PackageName } from "./PackageName.svg";
import { ReactComponent as RegionalTierList } from "./RegionalTierList.svg";
import {
  Svg2D,
  Svg3D,
  SvgActivity,
  SvgAdd,
  SvgAddCircular,
  SvgAirplane,
  SvgAlignBottom,
  SvgAlignCenterHorizontal,
  SvgAlignCenterVertical,
  SvgAlignLeft,
  SvgAlignRight,
  SvgAlignTop,
  SvgAndroid,
  SvgAnnotation,
  SvgApple,
  SvgArchive,
  SvgArrowDown,
  SvgArrowLeft,
  SvgArrowRight,
  SvgArrowUp,
  SvgAttach,
  SvgAutomatic,
  SvgAway,
  SvgBasket,
  SvgBentleySystems,
  SvgBlank,
  SvgBolt,
  SvgBookmark,
  SvgCalendar,
  SvgCamera,
  SvgCameraAnimation,
  SvgCameraAnimationDisabled,
  SvgCameraRetake,
  SvgCaretDown,
  SvgCaretDownSmall,
  SvgCaretLeft,
  SvgCaretLeftSmall,
  SvgCaretRight,
  SvgCaretRightSmall,
  SvgCaretUp,
  SvgCaretUpSmall,
  SvgCharts,
  SvgChat,
  SvgCheckboxDeselect,
  SvgCheckboxSelect,
  SvgCheckmark,
  SvgCheckmarkSmall,
  SvgChevronDown,
  SvgChevronLeft,
  SvgChevronLeftDouble,
  SvgChevronRight,
  SvgChevronRightDouble,
  SvgChevronUp,
  SvgCircle,
  SvgClash,
  SvgClipboard,
  SvgClock,
  SvgClose,
  SvgCloseCircular,
  SvgCloseSmall,
  SvgCloud,
  SvgCloudDownload,
  SvgCloudUpload,
  SvgCollapse,
  SvgCollapseAll,
  SvgColumnManager,
  SvgCompare,
  SvgComputer,
  SvgConfiguration,
  SvgCopy,
  SvgCrop,
  SvgCrown,
  SvgCursor,
  SvgCursorClick,
  SvgCut,
  SvgDatabase,
  SvgDelete,
  SvgDetails,
  SvgDeveloper,
  SvgDisconnect,
  SvgDistributeBottom,
  SvgDistributeCenterHorizontal,
  SvgDistributeCenterVertical,
  SvgDistributeLeft,
  SvgDistributeRight,
  SvgDistributeTop,
  SvgDockBottom,
  SvgDockLeft,
  SvgDockRight,
  SvgDockTop,
  SvgDocument,
  SvgDocumentation,
  SvgDocumentLock,
  SvgDocumentReference,
  SvgDownload,
  SvgDragHandle,
  SvgDragHandleVertical,
  SvgDraw,
  SvgDuplicate,
  SvgEdit,
  SvgEditAll,
  SvgEllipse,
  SvgEmail,
  SvgEmailAt,
  SvgExit,
  SvgExpand,
  SvgExpandAll,
  SvgExport,
  SvgEyedropper,
  SvgEyedropperDrop,
  SvgEyedropperFilled,
  SvgFastBackward,
  SvgFastForward,
  SvgFeedback,
  SvgFilter,
  SvgFilterHollow,
  SvgFind,
  SvgFireExtinguisher,
  SvgFitToView,
  SvgFlag,
  SvgHistory,
  SvgImageFrame,
  SvgImodelHollow,
  SvgList,
  SvgMenu,
  SvgNetwork,
  SvgPalette,
  SvgPlugin,
  SvgProject,
  SvgReplace,
  SvgScriptRun,
  SvgSortDown,
  SvgSortUp,
  SvgUser,
  SvgUsers,
  SvgValidate,
} from "@itwin/itwinui-icons-react";

const Icons = {
  LinkageAttribute,
  BecsLogo,
  BecsIcon,
  LogAnim,
  Log,
  AdministrationAnim,
  ArchitectsManagementAnim,
  ArchitectsManagement,
  SubscribedProjectsAnim,
  ListAnim,
  ScriptRunAnim,
  DetailsAnim,
  ConfirmScript,
  Attachment,
  ExecutionTypeList,
  IndustryList,
  LifeCycleList,
  MonitorList,
  PackageName,
  RegionalTierList,
  Administration,
  IModelValueList,
  ARExperience,
  Attributes,
  ColorSettings,
  ColourSettings,
  DawWebScreen,
  Mapping,
  PasswordManagement,
  TabListing,
  Projects,
  SubscribedProjects,
  Organizations,
  SubscribedOrganizations,
  ApiTesting,
  OnPremRouting,
  StatusSuccessColor,
  StatusSuccessColorMuted,
  Interoperability,
  Svg2D,
  Svg3D,
  SvgActivity,
  SvgAdd,
  SvgAddCircular,
  SvgAirplane,
  SvgAlignBottom,
  SvgAlignCenterHorizontal,
  SvgAlignCenterVertical,
  SvgAlignLeft,
  SvgAlignRight,
  SvgAlignTop,
  SvgAndroid,
  SvgAnnotation,
  SvgApple,
  SvgArchive,
  SvgArrowDown,
  SvgArrowLeft,
  SvgArrowRight,
  SvgArrowUp,
  SvgAttach,
  SvgAutomatic,
  SvgAway,
  SvgBasket,
  SvgBentleySystems,
  SvgBlank,
  SvgBolt,
  SvgBookmark,
  SvgCalendar,
  SvgCameraAnimationDisabled,
  SvgCameraAnimation,
  SvgCameraRetake,
  SvgCamera,
  SvgCaretDownSmall,
  SvgCaretDown,
  SvgCaretLeftSmall,
  SvgCaretLeft,
  SvgCaretRightSmall,
  SvgCaretRight,
  SvgCaretUpSmall,
  SvgCaretUp,
  SvgCharts,
  SvgChat,
  SvgCheckboxDeselect,
  SvgCheckboxSelect,
  SvgCheckmarkSmall,
  SvgCheckmark,
  SvgChevronDown,
  SvgChevronLeftDouble,
  SvgChevronLeft,
  SvgChevronRightDouble,
  SvgChevronRight,
  SvgChevronUp,
  SvgCircle,
  SvgClash,
  SvgClipboard,
  SvgClock,
  SvgCloseCircular,
  SvgCloseSmall,
  SvgClose,
  SvgCloudDownload,
  SvgCloudUpload,
  SvgCloud,
  SvgCollapseAll,
  SvgCollapse,
  SvgColumnManager,
  SvgCompare,
  SvgComputer,
  SvgConfiguration,
  SvgCopy,
  SvgCrop,
  SvgCrown,
  SvgCursorClick,
  SvgCursor,
  SvgCut,
  SvgDatabase,
  SvgDelete,
  SvgDetails,
  SvgDeveloper,
  SvgDisconnect,
  SvgDistributeBottom,
  SvgDistributeCenterHorizontal,
  SvgDistributeCenterVertical,
  SvgDistributeLeft,
  SvgDistributeRight,
  SvgDistributeTop,
  SvgDockBottom,
  SvgDockLeft,
  SvgDockRight,
  SvgDockTop,
  SvgDocumentLock,
  SvgDocumentReference,
  SvgDocument,
  SvgDocumentation,
  SvgDownload,
  SvgDragHandleVertical,
  SvgDragHandle,
  SvgDraw,
  SvgDuplicate,
  SvgEditAll,
  SvgEdit,
  SvgEllipse,
  SvgEmailAt,
  SvgEmail,
  SvgExit,
  SvgExpandAll,
  SvgExpand,
  SvgExport,
  SvgEyedropperDrop,
  SvgEyedropperFilled,
  SvgEyedropper,
  SvgFastBackward,
  SvgFastForward,
  SvgFeedback,
  SvgFilterHollow,
  SvgFilter,
  SvgFind,
  SvgFireExtinguisher,
  SvgFitToView,
  SvgFlag,
  SvgHistory,
  SvgMenu,
  SvgImodelHollow,
  SvgProject,
  SvgList,
  SvgPlugin,
  SvgImageFrame,
  SvgPalette,
  SvgReplace,
  SvgSortDown,
  SvgSortUp,
  SvgNetwork,
  SvgScriptRun,
  SvgUser,
  SvgUsers,
  SvgValidate,
};

export default Icons;
